import { render, staticRenderFns } from "./UICarouselItem.vue?vue&type=template&id=214504f8&"
import script from "./UICarouselItem.vue?vue&type=script&lang=js&"
export * from "./UICarouselItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports